//项目转合同弹窗
<template>
  <div class="dialog-body">
    <el-dialog title="招商入驻" :visible.sync="dialogVisible" append-to-body width="60%" center>
      <div class="formClass">
        <el-row :gutter="24">
          <el-col :span="6">
            <span>请确认商户入驻信息:</span>
          </el-col>
        </el-row>
        <formItem
          ref="dialogFormRef"
          :params="dialogData"
          :columns="baseColumns"
          :rules="rules"
          labelWidth="120px"
        >
        </formItem>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">确认入驻</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MerchantOverviewMixin from '@/pages/property/merchants/merchantCenter/overview/MerchantOverviewMixin';
  import formItem from '@/pages/intermodality/common/components/form-item.vue';
  import { entryDetailCells } from '../columns';

  export default {
    name: 'MerchantSettleDialog',
    mixins: [MerchantOverviewMixin],
    components: {
      formItem,
    },
    data() {
      return {
        dialogVisible: false,
        dialogData: {
          nicheNo: null,
          customerName: null,
          relatedContractNo: null,
          relatedContractStatus: null,
          leaseContractSpace: null,
          leaseSpaceArea: null,
          leaseDateFrom: null,
          leaseDateUntil: null,
          leaseDuration: null,
          leaseRentAmount: null,
          entryDate: null,
          merchantContactPerson: null,
          merchantContactPhone: null,
          id: null,
        },
        rules: {
          merchantContactPhone: [
            {
              required: true,
              message: '请填写联系电话',
              trigger: 'blur',
            },
          ],
          merchantContactPerson: [
            {
              required: true,
              message: '请填写联系人',
              trigger: 'blur',
            },
          ],
          entryDate: [
            {
              required: true,
              message: '入驻日期',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    computed: {
      baseColumns() {
        return entryDetailCells();
      },
    },
    methods: {
      async openDialog(id) {
        this.dialogVisible = true;
        if (id) {
          this.loading.startLoading();
          let data = await this.getEntryDetail(id);
          for (let key in this.dialogData) {
            this.dialogData[key] = data[key];
          }
          this.dialogData.id = id;
          this.dialogData.leaseDuration =
            this.formatDateCustom(this.dialogData.leaseDateFrom, false) +
            '~' +
            this.formatDateCustom(this.dialogData.leaseDateUntil, false);
          this.loading.endLoading();
        }
        this.$refs.dialogFormRef.clearValidate();
      },
      handleClose() {
        this.dialogVisible = false;
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
      },
      handleSure() {
        this.$refs['dialogFormRef'].validate(async (valid) => {
          if (valid) {
            const { id, entryDate, merchantContactPhone, merchantContactPerson } = this.dialogData;
            let data = { id, entryDate, merchantContactPerson, merchantContactPhone };
            this.loading.startLoading();
            let res = await this.submitEntry(data);
            this.loading.endLoading();
            if (res == 'success') {
              this.handleClose();
              this.$emit('handleSure');
            }
          }
        });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .formClass {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog-footer {
    text-align: center;
  }
</style>
